import {Routes} from '@angular/router';
import {PlatformLinkCreatorComponent} from '@shared/components/platform-tool/platform-link-creator/platform-link-creator.component';
import {PlatformToolContainerComponent} from '@shared/components/platform-tool/platform-tool-container/platform-tool-container.component';

export const transactionTrackerRoutes: Routes = [
  {
    path: 'transaction-tracker/transactions',
    component: PlatformLinkCreatorComponent
  },
  {
    path: 'transaction-tracker/entities',
    component: PlatformLinkCreatorComponent
  },
  {
    path: 'transaction-tracker/consolidation-rules',
    component: PlatformLinkCreatorComponent
  },
  {
    path: 'transaction-tracker/consolidation-rules/:magicLinkId',
    component: PlatformToolContainerComponent
  },
  {
    path: 'transaction-tracker/consolidation-transactions',
    component: PlatformLinkCreatorComponent
  },
  {
    path: 'transaction-tracker/buckets/:magicLinkId',
    component: PlatformToolContainerComponent
  },
  {
    path: 'transaction-tracker/buckets',
    component: PlatformLinkCreatorComponent
  },
  {
    path: 'transaction-tracker/analytics',
    component: PlatformLinkCreatorComponent
  },
  {
    path: 'transaction-tracker/custom-rates/fx-rates',
    component: PlatformLinkCreatorComponent
  },
  {
    path: 'transaction-tracker/custom-rates/wht-rates',
    component: PlatformLinkCreatorComponent
  },
  {
    path: 'transaction-tracker/data-mapping/field-mapping',
    component: PlatformLinkCreatorComponent
  },
  {
    path: 'transaction-tracker/data-mapping/entity-mapping',
    component: PlatformLinkCreatorComponent
  },
  {
    path: 'transaction-tracker/data-mapping/stream-mapping',
    component: PlatformLinkCreatorComponent
  }
];
